import { createFileRoute } from '@tanstack/react-router';

// relative imports
import CheckoutPage from '../../components/billing/tax-checkout/CheckoutPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/tax-checkout')({
  component: CheckoutPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    hideAccountMenu: true,
    hideSecondaryMenu: true,
    meta: {
      title: 'Checkout | Ledgible',
    },
  },
});
